import { ScrollTrigger }        from "gsap/ScrollTrigger";

import SwiperGalleries  from './SwiperGallery';
import * as Menu                    from "./Menu";
window.$ = window.jQuery    = require('jquery');

const AjaxLoadPage = function()
{
	const _body                 = $('body');
	const _header               = $('#header');    
	const _introLayer           = $("#layerIntroPage");
	const _webdoorMotion 		= $("#webdoor");
	const _btFale 				= $("#fale-bt-link");
	const _loadElm 				= $("#loader-container");

	const pageLoader = function() {
		
		
		setTimeout(() => {
			
			_body.removeClass('scroll-off body-content-loading');			               			
			
		
			_loadElm.fadeOut(300); 

			setTimeout(()=>{
				_introLayer.removeClass('motion-in '); 
			},500)

			setTimeout(()=>{
				_introLayer.addClass('motion-out');
				_webdoorMotion.addClass("motion-in");
				_btFale.addClass("motion-in");
				_header.addClass('motion-in');
				SwiperGalleries.gallerySwiperWebdoor();
				SwiperGalleries.galleryPadrao();
				SwiperGalleries.galleryAreas();
				SwiperGalleries.galleryAndamento();
				SwiperGalleries.galleryAptos();
				SwiperGalleries.galleryProjetistas();
				SwiperGalleries.galleryHorz();
				// SwiperGalleries.galleryBasicSwiper();
				Menu.init();
				setTimeout(function () {
					ScrollTrigger.refresh();
				}, 300);
			},1000)

		}, _timerSync);

	}

   
	return {
		init : function(status){

			pageLoader(status);			
			/* $('a[href]').not('.no-load').on('click',  (e) => {
			    e.preventDefault();
			    _introLayer.removeClass('motion-out');
			    // _introLayer.addClass('motion-in');
			    setTimeout(()=>{
			        window.location.href=e.currentTarget.getAttribute('href');
			    },1000)
			}); */

		}
	}

}();

export default  AjaxLoadPage;